function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m635.94 324.18h-38.688v320.64c-0.007812 3.8867-1.5586 7.6133-4.3047 10.359-2.75 2.75-6.4727 4.2969-10.359 4.3086h-149.35c-3.8945 0-7.6289-1.5469-10.383-4.293-2.7578-2.75-4.3086-6.4805-4.3203-10.375v-157.2c-0.76562-23.977-13.996-45.809-34.898-57.582-20.898-11.773-46.43-11.773-67.332 0-20.898 11.773-34.133 33.605-34.898 57.582v157.2c-0.007812 3.8945-1.5625 7.625-4.3164 10.375-2.7578 2.7461-6.4883 4.293-10.383 4.293h-149.3c-3.8867-0.011719-7.6094-1.5586-10.359-4.3086-2.7461-2.7461-4.2969-6.4727-4.3047-10.359v-320.64h-38.688c-8.0664-0.027344-15.758-3.4023-21.238-9.3203-5.4805-5.918-8.2578-13.848-7.6641-21.891 0.58984-8.043 4.4961-15.48 10.785-20.531l278.6-222.86h-0.003907c7.1992-5.8711 16.203-9.0781 25.488-9.0781 9.2891 0 18.289 3.207 25.488 9.0781l278.6 222.86h-0.003907c6.293 5.0547 10.199 12.5 10.789 20.551 0.58594 8.0508-2.1992 15.98-7.6914 21.898-5.4922 5.9141-13.195 9.2812-21.27 9.293z",
    fillRule: "evenodd",
    style: {
      fill: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.6d7bd681c9cb69ada3fc9102c1492276.svg";
export { ForwardRef as ReactComponent };